export default __webpack_public_path__ + "static/media/brand.c422858d.webp";